// extracted by mini-css-extract-plugin
export default {"root":"_2GJGa","transform":"_33lom","swipeable":"iY3mN","preview":"_1GJhZ","next":"_1nMIL","prev":"_1HW7A"};